<div class="flex flex-row flex-align-center-end">
	<button (click)="routeToGlobalDashboard()" class="global-dashboard-button" mat-flat-button>Global Dashboard</button>
</div>
